// **********************************************************
// Toggle House Info
// **********************************************************

const houseMatrix = document.querySelector('.house-matrix');

if (houseMatrix) {
  // set active house tab
  const setActiveHouseTab = (id) => {
    const tabs = houseMatrix.querySelectorAll('.house-tabs__btn');
    tabs.forEach((tab) => tab.classList.remove('is-active'));
    houseMatrix.querySelector(`.house-tabs__btn[data-id="${id}"]`).classList.add('is-active');
  };

  // get house matrix cards
  const houseMatrixContentEl = houseMatrix.querySelector('.house-matrix__content');
  const houseMatrixTabsEl = houseMatrix.querySelector('.house-matrix__tabs');
  const axiosGetHouseMatrixCards = async (parentEle) => {
    const action = 'getHouseMatrixCards';
    const formDataInput = {
      action,
      model: houseMatrix.querySelector('input[name="house_matrix_model"]:checked').dataset.filter,
      size: houseMatrix.querySelector('input[name="house_matrix_size"]:checked').dataset.filter,
      nonce: await getNonceForAction(action),
      dataKey: parentEle.dataset.key,
      id: localData.id,
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      if (response.data.data.html_house_info) {
        houseMatrixContentEl.innerHTML = response.data.data.html_house_info;
      }

      houseMatrixTabsEl.innerHTML = '';
      if (response.data.data.html_house_tabs) {
        houseMatrixTabsEl.innerHTML = response.data.data.html_house_tabs;
      }

      if (response.data.data.text__not_found) {
        houseMatrixContentEl.innerHTML = response.data.data.text__not_found;
      }

      if (response.data.data.html_area_selection) {
        const houseMatrixAreaSelectionEl = houseMatrix.querySelector('.house-matrix__area-selection');
        houseMatrixAreaSelectionEl.innerHTML = response.data.data.html_area_selection;
      }

      parentEle.classList.remove('is-open-details');
    } catch (err) {
      console.error(err);
    }
  };

  // get house matrix info
  const axiosGetHouseMatrixInfo = async (parentEle, houseId) => {
    const action = 'getHouseMatrixInfo';
    const formDataInput = {
      action,
      houseId,
      nonce: await getNonceForAction(action),
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      houseMatrixContentEl.innerHTML = response.data.data.html_house_info;
      parentEle.classList.add('is-open-details');
    } catch (err) {
      console.error(err);
    }
  };

  // click on house card
  attachEvent('.house-matrix .image-card-list__item', 'click', (ele) => {
    const houseId = ele.target.closest('.image-card-list__item').dataset.id;
    setActiveHouseTab(houseId);
    axiosGetHouseMatrixInfo(ele.target.closest('.house-matrix'), houseId);
  });

  // click on house tab
  attachEvent('.house-matrix .house-tabs__btn', 'click', (ele) => {
    const houseId = ele.target.dataset.id;
    setActiveHouseTab(houseId);
    axiosGetHouseMatrixInfo(ele.target.closest('.house-matrix'), houseId);
  });

  // change house matrix filter
  attachEvent('.house-matrix .radio-button-group input', 'change', (ele) => {
    axiosGetHouseMatrixCards(ele.target.closest('.house-matrix'));
  });
}
